export default {
  labels: {
    dont_have_account: 'Não tem uma conta? ',
  },
  title: 'Junte-se a {{name}}!',
  default_program_name: 'Clube de Recompensas',
  buttons: {
    sign_up: 'Registar',
  },
};
